import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import CardTitle from '../../Elements/CardTitle/CardTitle';
import Button from '../../Input/Button/Button';
/* COMPONENTS */
import CardHeader from '../CardHeader/CardHeader';
import SingleGroup from '../SingleGroup/SingleGroup';
/* STYLESHEETS */
import './ExploreSection.scss';

export default class ExploreSection extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * array of popular groups
         */
        popularGroups: PropTypes.array.isRequired,
        /**
         * array of new groups
         */
        newGroups: PropTypes.array.isRequired,
    };

    renderSingleGroup = (group, index) => {
        return <SingleGroup key={`group-${index}`} {...group} />;
    };

    handleMetrics = () =>
        EmitMetric({
            misc_event_type: 'see-all-groups-click',
            misc_event_count: 1,
        });

    render() {
        return (
            <section className="component-Groups-ExploreSection">
                <CardTitle className="explore-groups-header">
                    Explore groups
                </CardTitle>

                <CardHeader cssClass="popular-groups-header">
                    Popular Groups
                </CardHeader>
                <ul className="popular-groups-list">
                    {this.props.popularGroups.map(this.renderSingleGroup)}
                </ul>

                <CardHeader cssClass="new-groups-header">New Groups</CardHeader>
                <ul className="new-groups-list">
                    {this.props.newGroups.map(this.renderSingleGroup)}
                </ul>

                <a href="/groups/all">
                    <Button
                        onClick={this.handleMetrics}
                        type="purple-medium-white"
                        value="See all groups"
                        className="see-all-groups-btn"
                    />
                </a>
            </section>
        );
    }
}
